class Entities {
  #entities = new Map();

  set(key, value) {
    this.#entities.set(key, value);
  }

  get(key) {
    return this.#entities.get(key);
  }

  delete(key) {
    this.#entities.delete(key);
  }
}

const entities = new Entities();
export { Entities, entities };
